<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Clientes",
            items: [
                {
                    text: "Inicio",
                    href: "/"
                },
                {
                    text: "clientes",
                    active: true
                }
            ],
            clientes:{},
            cliente:null,
            isLoading:false,
            datos:{
                name:''
            }
        };
    },
    methods: {
        get_data(){
            this.isLoading=true
            try {
                axios.get('/api/clientes').then(res=>{
                    this.clientes = res.data.datos;
                    this.$toasted.success('Datos cargados!');
                })  
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading=false
            }
        },
        agregar(){
            this.isLoading=true
            axios.post('/api/clientes',this.datos).then(res=>{
                if(res.data.estado){
                    this.cliente = res.data.cliente;
                    this.datos.name=''
                    this.get_data()
                }else{
                    alert('error al agregar')
                }
                this.isLoading=false
            })
        },
        eliminar(id){
            this.isLoading=true
            axios.delete('/api/clientes/'+id).then(res=>{
                this.clientes = res.data.datos;
                this.get_data()
                this.isLoading=false
            })
        }
    },
    mounted() {
        this.get_data()
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-6">
                <div class="card">
                    <div class="card-body">
                        <table class="table">
                            <thead>
                                <th class="py-0 px-1">#</th>
                                <th class="py-0 px-1">NOMBRE</th>
                                <th class="py-0 px-1">DESCRIPCION</th>
                                <th class="py-0 px-1"></th>
                            </thead>
                            <tbody>
                                <tr v-for="(m, i) in clientes" :key="i">
                                    <td class="py-0 px-1">{{ i + 1 }}</td>
                                    <td class="py-0 px-1">{{ m.name }}</td>
                                    <td class="py-0 px-1">{{ m.descripcion }}</td>
                                    <td class="py-0 px-1">
                                        <div class="btn-group">
                                            <a @click="eliminar(m.id)" class="btn btn-danger btn-sm py-1 px-2">
                                                <i class="fas fa-trash"></i>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="card">
                    <div class="card-body">
                        <b-form-group label-cols-sm="12" label-cols-lg="3"  label="Nombre">
                            <b-form-input for="text" placeholder="Nombre" v-model="datos.name"  ></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols-sm="12" label-cols-lg="3"  label="Descripcion">
                            <b-form-input for="text" placeholder="Descripcion" v-model="datos.descripcion"  ></b-form-input>
                        </b-form-group>
                        <b-button v-show="datos.name!==''" block variant="success" @click="agregar()">Agregar</b-button>
                        <loading-message v-if="isLoading" />
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>